import React, { useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Pressable, StyleSheet, Text, View } from 'react-native';
import {
  DialogButtonProps,
  DialogProps,
} from 'shared/components/vxl/Dialog/Dialog';
import theme from 'shared/styles/theme';

const BUTTON_ROW = 1;
const BUTTON_COLUMN = 0;
const MAX_BUTTON_ROW_HEIGHT = 59;

const AndroidButtonContainer = ({ dialogButtonProps }: DialogProps) => {
  const [buttonLayoutOrientation, setButtonLayoutOrientation] =
    useState(BUTTON_ROW);

  const getFlexValue = (index: number) => {
    if (index === 0 && buttonLayoutOrientation === BUTTON_ROW) {
      return styles.flexValue1;
    }
    return styles.flexValue0;
  };

  const getLayoutOrientation = () => {
    return buttonLayoutOrientation === BUTTON_ROW
      ? styles.flexDirectionRow
      : styles.flexDirectionColumn;
  };

  const getAlignSelf = (index: number) => {
    if (
      dialogButtonProps.length > 2 &&
      index === 0 &&
      buttonLayoutOrientation === BUTTON_ROW
    ) {
      return styles.alignSelfStart;
    }
    return styles.alignSelfEnd;
  };

  const getMarginEnd = (index: number) => {
    if (
      index !== dialogButtonProps.length - 1 &&
      buttonLayoutOrientation === BUTTON_ROW
    ) {
      return styles.marginEndValue8;
    }
    return styles.marginEndValue0;
  };

  const getMarginTop = (index: number) => {
    if (
      dialogButtonProps.length > 1 &&
      buttonLayoutOrientation === BUTTON_COLUMN &&
      index !== 0
    ) {
      return styles.marginTopValue8;
    }
    return styles.marginTopValue0;
  };

  return (
    <View
      style={[styles.androidButtonContainer, getLayoutOrientation()]}
      onLayout={(e) => {
        if (
          e.nativeEvent.layout.height >= MAX_BUTTON_ROW_HEIGHT ||
          dialogButtonProps.length > 3
        ) {
          setButtonLayoutOrientation(BUTTON_COLUMN);
        }
      }}
    >
      {dialogButtonProps?.map((item: DialogButtonProps, index: number) => {
        return (
          <View
            key={`Button-${item.label}`}
            style={[
              getMarginEnd(index),
              getMarginTop(index),
              getFlexValue(index),
            ]}
          >
            <Pressable
              onPress={() => {
                if (item.onClick) {
                  item.onClick();
                }
              }}
              style={getAlignSelf(index)}
            >
              <View style={styles.androidButton}>
                <Text
                  numberOfLines={
                    buttonLayoutOrientation === BUTTON_COLUMN ? 1 : 2
                  }
                  style={styles.androidButtonText}
                >
                  {item.label}
                </Text>
              </View>
            </Pressable>
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  alignSelfEnd: {
    alignSelf: 'flex-end',
  },
  alignSelfStart: {
    alignSelf: 'flex-start',
  },
  androidButton: {
    paddingBottom: 10,
    paddingEnd: 12,
    paddingStart: 12,
    paddingTop: 10,
  },
  androidButtonContainer: {
    marginEnd: theme.spacing.l,
    marginStart: 12,
    marginTop: theme.spacing.l,
  },
  androidButtonText: {
    color: theme.color.interactive.primary,
    fontSize: 14,
    fontWeight: '500',
    letterSpacing: 0.1,
    lineHeight: 20,
  },
  flexDirectionColumn: {
    flexDirection: 'column',
  },
  flexDirectionRow: {
    flexDirection: 'row',
  },
  flexValue0: {
    flex: 0,
  },
  flexValue1: {
    flex: 1,
  },
  marginEndValue0: {
    marginEnd: 0,
  },
  marginEndValue8: {
    marginEnd: theme.spacing.s,
  },
  marginTopValue0: {
    marginTop: 0,
  },
  marginTopValue8: {
    marginTop: theme.spacing.s,
  },
});

export default AndroidButtonContainer;
